import React, { useState, useRef, useEffect } from 'react';
import './ThemeSelect.css';

export default function ThemeSelect({ value, onChange, options, className }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => String(opt.value) === String(value)) || options[0];

  return (
    <div className={`theme-select-container ${className || ''}`} ref={dropdownRef} style={{ zIndex: isOpen ? 9999 : 1 }}>
      <div 
        className="theme-select-header" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption ? selectedOption.label : value}
        <span className={`theme-select-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      {isOpen && (
        <div className="theme-select-list">
          {options.map(opt => (
            <div 
              key={opt.value} 
              className={`theme-select-item ${String(opt.value) === String(value) ? 'selected' : ''}`}
              onClick={() => {
                onChange({ target: { value: opt.value } });
                setIsOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
